export default "__VITE_ASSET__xxVbcD73__"